export default __webpack_public_path__ + "static/media/greenPin.a3b85626.svg";